/* eslint-disable react-hooks/rules-of-hooks */
import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { CButton } from "@app/components/Common/";

import { TradeDetailListSection, TradeText } from "./styles";

import useTradeStore from "../../../../hooks/trade/tradeStore";
import { useToken } from "@app/hooks";
import { AuthCheckText } from "@app/components";
import { useTradePosition } from "../../../../hooks/trade/tradePosition";
import NoData from "../../../../components/Common/CFlatList/NoData";
import { Text, View } from "../../../../../styles/reactnative";
import {
	Button,
	Space,
	Table,
	Tag,
	message,
} from "antd";
import KrwPrice from "../../../../components/KrwPrice";
import { useTranslation } from "react-i18next";
import { getSetting, useSetting } from "../../../../hooks/user/mysetting";
import { ThemeContext } from "../../../../../theme/ThemeProvider";
import { useTradeModalStore } from "../../../../hooks/trade/modalStore";
import { COLORS } from "../../../../constants";
import BigNumber from "bignumber.js";
import { SETTING_TYPE_SYSTEM } from "../../../../constants/SETTING";
import { useIndexPrice } from "../../../../hooks/trade/indexprice";
import { useExchangeStore } from "../../../../hooks/trade/exchangeStore";
import API from "../../../../../utils/api";
import { CANCELORDER } from "../../../../constants/APIKEYS";
import EntryTime from "../../../../components/EntryTime";
import TPSLEDIT from "../TPSLEDIT";
import { useMitOrder } from "../../../../hooks/trade/mitorder";
import { useTradeSetting } from "../../../../hooks/trade/tradeSetting";
import ContractsColumn from "../Columns/ContractsColumn";
import { formatDecimal4Truncate } from "@/utils/formatDecimal";
import { useIsMobile } from '@utils/CalVW.tsx';
import CNoDataFound from '@components/Common/CNoDataFound';
import EmptyMessage from "@/app/components/EmptyMessage";
import useScrollLayout from "../useScrollLayout";

const TradeActiveTable = ({ parentHeight }) => {
	const { data: token } = useToken();
  const isMobile = useIsMobile();
	const { textw, content, header, textsilver } =
		useContext(ThemeContext).theme.COLORS;
	const { isDarkMode } = useContext(ThemeContext);
	const { t } = useTranslation();
	const containerRef = useRef<HTMLDivElement>(null);

	const [shareData, setShareData] = React.useState<any>(null);

	const [closeAll, setCloseAll] = React.useState(false);

	const { mutate: mutateModalStore, data: modalStore } = useTradeModalStore();

	const { data: tradeStore } = useTradeStore();

	const { data: setting, updateSetting } = useSetting(SETTING_TYPE_SYSTEM);
	const equivshow = getSetting(setting, "EQUIVSHO", 1) == 1 ? true : false;

	const { getPrice } = useIndexPrice(tradeStore?.ep_id || 0);

	const { data: tradeSetting } = useTradeSetting(tradeStore?.ep_id);

	const { EPs } = useExchangeStore();
	const { data, orderlist, mutate } = useTradePosition();

	const { data: mitdata, mutate: mutateMit } = useMitOrder();

	let list = orderlist?.length > 0 ? [...orderlist] : [];

	const [mit, setMit] = useState<any>([]);

	list = [...mit, ...list];

	const { needsScroll, headerHeight } = useScrollLayout(containerRef, list, parentHeight);

	const orderType = tradeStore?.main_sub || "M";

	//console.log('itemitemitem', list)

	useEffect(() => {
		const keys = Object.keys(mitdata || []);

		for (const key of keys) {
			if (key == "NO") continue;

			let mitlist: any = [];
			const item = mitdata[key];


			item?.map((mit: any) => {
				const temp = {
					status: 10,
					exchange_pairs_id: parseInt(key?.replace("MIT", "")),
					leverage: tradeSetting?.leverage || 1,
					limit_market: mit.limit_market == "CL" ? "L" : "M",
					order_price: mit.price,
					trigger_price: mit.trigger_price,
					trigger_type: mit.trigger_type,
					long_short: mit.longshort,
					amount: mit?.amount,
					created_at: mit?.created_at,
				};
				mitlist.push(temp);
			});
			setMit([...mitlist]);
		}

		return () => {
			setMit([]);
		};
	}, [mitdata]);

	data?.map((item: any) => {
		if (item?.tpsl) {
			const TPSL = item?.tpsl?.[0];

			if (TPSL) {
				if (+TPSL?.tp != 0) {
					list = [
						{
							...item,
							posid: item?.id,
							posprice: item?.price,
							poslongshort: item?.long_short,
							status: 1,
							limit_market: "L",
							long_short: item?.long_short == "L" ? "S" : "L",
							order_price: +TPSL?.tp,
							type: "TP",
							tpsltype: TPSL?.tp + " " + TPSL?.tptype,
							tpsl: TPSL,
						},
						...list,
					];
				}
				if (+TPSL?.sl != 0) {
					list = [
						{
							...item,
							posid: item?.id,
							posprice: item?.price,
							poslongshort: item?.long_short,
							status: 1,
							limit_market: "L",
							long_short: item?.long_short == "L" ? "S" : "L",
							order_price: +TPSL?.sl,
							type: "SL",
							tpsltype: TPSL?.sl + " " + TPSL?.sltype,
							tpsl: TPSL,
						},
						...list,
					];
				}
			}
		}
	});

	if (modalStore?.iscurrent) {
		list = list?.filter(
			(item: any) => item?.exchange_pairs_id == tradeStore?.ep_id
		);
	}

	useEffect(() => {
		if (closeAll) {
			{
				orderlist?.map((item: any) => {
					API.post(CANCELORDER, token + "", {
						orderid: item?.id,
					}).then((res) => {
						mutate();
					});
				});
			}
		}
	}, [closeAll]);

	return (
		<TradeDetailListSection ref={containerRef}>
			{token ? null : <AuthCheckText />}

			{list?.length ? (
				<Table
					showHeader={true}
					bordered={false}
					dataSource={list}
					rootClassName={"table" + (isDarkMode ? "dark" : "light")}
					columns={[
						{
							width: '14.2%',
							title: t("contracts") + "",
							dataIndex: "contracts",
							align: "left",
							key: "contracts",
							render: (text: any, item) => <ContractsColumn item={item} />,
						},
						{
							width: '14.2%',
							title: t("qty") + "",
							dataIndex: "amount",
							key: "amount",
							align: "left",
							render: (text: any, item) => {
								const EP = EPs?.find(
									(item2: any) => +item2.id == +item?.exchange_pairs_id
								);
								const coin = EP?.pairs?.split("/")[0];
								const currentPrice = getPrice(item?.exchange_pairs_id);
								return (
									<TradeText
										style={{
											letterSpacing: 0,
											minWidth: 90,
											whiteSpace: 'nowrap',
											lineHeight: 'normal',
											flexDirection: 'column',
											alignItems: 'left',
											fontWeight: 'bold',
										}}
									>
										{orderType === 'M' ? BigNumber(item?.amount)
											.multipliedBy(item?.leverage)
											.toFormat(4) :
											BigNumber(item?.amount)
												.multipliedBy(currentPrice)
												.multipliedBy(item?.leverage)
												.toFormat(4)
										}{" "}
										{orderType === 'M' ? coin : 'USDT'}
									</TradeText>
								);
							},
						},
						{
							width: '14.2%',
							title: t("orderPrice") + "",
							dataIndex: "open_price",
							key: "open_price",
							align: "left",
							render: (text: any, item) => {
								const EP = EPs?.find(
									(item2: any) => +item2.id == +item?.exchange_pairs_id
								);

								return (
									<div>
										{item?.status == 10
											? item?.limit_market == "L"
												? t("climit") +
												" (" +
												BigNumber(item?.order_price).toFormat(EP?.dp2 || 3) +
												")"
												: t("cmarket")
											: ""}

										{item?.status == 10 ? (
											<div style={{ fontSize: 14 }}>
												<div
													style={{
														color: textsilver,
														fontSize: 14,
													}}
												>
													{t("triggerPrice")}
												</div>{" "}
												{item?.trigger_type == "BIG" ? "<=" : ">="}
												{item?.trigger_price}
											</div>
										) : (
											<div style={{ fontSize: 14 }}>
												{item?.limit_market == "L"
													? item?.order_price
													: t("market")}
											</div>
										)}
									</div>
								);
							},
						},
						{
							width: '14.2%',
							title: t("markPrice") + "",
							dataIndex: "mark_price",
							key: "mark_price",
							align: "left",
							render: (text: any, item) => {
								const EP = EPs?.find(
									(item2: any) => +item2.id == +item?.exchange_pairs_id
								);
								return (
									<div
										style={{

										}}
									>
										{BigNumber(getPrice(item?.exchange_pairs_id)).toFormat(
											EP?.dp || 3
										)}
									</div>
								);
							},
						},
						{
							width: '14.2%',
							title: t("margin") + "",
							dataIndex: "margin",
							key: "margin",
							align: "left",
							render: (text: any, item) => {
								const EP = EPs?.find(
									(item2: any) => +item2.id == +item?.exchange_pairs_id
								);
								const currency = EP?.pairs?.split("/")[1];
								return (
									<div
										style={{

										}}
									>
										<KrwPrice
											price={formatDecimal4Truncate(item?.margin)}
											currency={currency}
											color={false}
											equiv={true}
											dp={4}
										/>
									</div>
								);
							},
						},
						{
							width: '14.2%',
							title: t("orderTime") + "",
							dataIndex: "created_at",
							key: "created_at",
							align: "left",
							render: (text: any, item) => {
								return <EntryTime time={item?.created_at} style={{ justifyContent: "flex-start" }} />;
							},
						},
						{
							title: (
								<div>
									<Button
										type="primary"
										size="small"
										onClick={() => {
											setCloseAll(true);
										}}
									>
										{t("entire")} {t("cancel") + ""}
									</Button>
								</div>
							),
							dataIndex: "close_by",
							key: "close_by",
							align: "left",
							render: (text: any, item) => {
								if (item?.type == "TP" || item?.type == "SL") {
									return (
										<View style={{ flexDirection: "row" }}>
											<Tag>{t(item?.type)}</Tag>
											<TPSLEDIT
												posid={item?.posid}
												tpsl={item?.tpsl}
												price={item?.posprice}
												amount={item?.leverage}
												long_short={item?.poslongshort}
												leverage={item?.leverage}
												margin={item?.margin}
											/>
										</View>
									);
								}
								return (
									<div>
										<CButton
											title={t("cancel")}
											onClick={() => {
												if (item?.status == 10) {
													const temp = mitdata[
													"MIT" + item?.exchange_pairs_id
														]?.filter(
														(mit: any) =>
															!(
																mit.limit_market == "C" + item?.limit_market &&
																+mit.price == +item?.order_price &&
																mit.longshort == item?.long_short
															)
													);

													mutateMit(temp, item?.exchange_pairs_id);

													console.log('item?.id', item, temp )

													API.post(CANCELORDER, token + "", {
														orderid: item?.id,
														is_triggered: !!item?.trigger_type,
													}).then((res) => {
														mutate();
													});

													message.success(
														t(item?.limit_market == "L" ? "climit" : "cmarket") +
														" 주문 취소 완료되었습니다."
													);
												} else {
													API.post(CANCELORDER, token + "", {
														orderid: item?.id,
													}).then((res) => {
														mutate();
													});
												}
											}}
											style={{
												background: COLORS.BTN_HOVER,
												marginLeft: 10,
												marginTop: -5,
												padding: "5px 10px ",
											}}
										/>
									</div>
								);
							},
						},
					]}
					pagination={false}
					style={{ width: "100%", height: "100%" }}
					sticky={true}
					scroll={
            isMobile ? { x: 850 } : needsScroll ? {
              x: 'max-content',
              y: parentHeight - 20 - (headerHeight || 38)
            } : {
              x: 'max-content' 
            }
					}
					size="small"
				/>
			) : (
				<View
					style={{
						flex: 1,
						height: '100%',
						alignItems: 'center',
						justifyContent: 'center',
					}}
				>
          {isMobile ?
            <CNoDataFound
              noDataTitle={"currentPositionTitle"}
              noDataContent={undefined}
              noDataSize={undefined}
              noDataHeight={'180px'}
              lottieSize={undefined}
            />
            :
            <EmptyMessage />
          }
				</View>
			)}
		</TradeDetailListSection>
	);
};

export default TradeActiveTable;

